<div class="content-management">
    <mat-tab-group #tab (selectChange)="tabChanged($event)">
        <mat-tab label="Events" [disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents">
            <ng-template mat-tab-label>
                <mat-icon>event</mat-icon>
                Events
                <span style="margin-left: 64px" *ngIf="!toggles.eventByGeolocation&&!toggles.manualEvents">
                    <upgrade-button [show]="true" [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>
            </ng-template>
            <ig-row>
                <ig-col [md]="6">
                    <div class="panel fb-place-wrap">
                        <div class="panel-header">
                            <h1 [class.text-disabled]="!toggles.manualEvents">Create Event Manually</h1>
                            <upgrade-button [show]="!toggles.manualEvents"
                                            [css]="'upgrade-create-place'"></upgrade-button>
                        </div>
                        <ig-hub-create-event></ig-hub-create-event>
                    </div>
                </ig-col>
                <ig-col [md]="6">
                    <div class="panel fb-place-wrap fixed-height-panel">
                        <div class="panel-header">
                            <h1 [class.text-disabled]="!toggles.eventByGeolocation">Edit Facebook Business Pages List
                            </h1>
                            <upgrade-button [show]="!toggles.eventByGeolocation"
                                            [css]="'upgrade-create-place'"></upgrade-button>
                        </div>
                        <ig-list>
                            <div header>
                                <ig-list-column-header>
                                    <div>Events are pulling from these social media pages</div>
                                    <span [class.text-disabled]="!toggles.eventByGeolocation"
                                          class="list-header-operation"
                                          (click)="toggles.eventByGeolocation&&addEventPage()"><mat-icon>add</mat-icon><span
                                        text>Add</span></span>
                                </ig-list-column-header>
                            </div>
                            <div body>
                                <ig-spinner *ngIf="isLoadingSpiderEventPages"></ig-spinner>
                                <ng-container *ngIf="!isLoadingSpiderEventPages&&toggles.eventByGeolocation">
                                    <ig-list-item *ngFor="let page of spiderEventPages">
                                        <div style="flex: 4">
                                            {{ page.url }} - {{ page.socialName }}
                                        </div>
                                        <ig-row-action-buttons style="flex: 1">
                                            <mat-icon matTooltip="change" (click)="editEventPage(page)">
                                                edit
                                            </mat-icon>
                                            <mat-icon matTooltip="remove" (click)="removeEventPage(page)">
                                                clear
                                            </mat-icon>
                                        </ig-row-action-buttons>
                                    </ig-list-item>
                                    <div *ngIf="!spiderEventPages||!spiderEventPages.length" class="empty-list">
                                        No Content Here...
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!isLoadingSpiderEventPages&&!toggles.eventByGeolocation">
                                    <ig-list-item *ngFor="let page of [0,1,2]">
                                        <div style="flex: 4" class="text-disabled">
                                            http://www.facebook.com/pg/example/events - Facebook
                                        </div>
                                    </ig-list-item>
                                </ng-container>
                            </div>
                        </ig-list>
                    </div>

                    <ig-upload-events class="full-width"></ig-upload-events>

                    <div class="panel fb-place-wrap">
                        <div class="panel-header">
                            <h1 [class.text-disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents">
                                Export Event PDF Header Image</h1>
                            <upgrade-button [show]="!toggles.eventByGeolocation&&!toggles.manualEvents"
                                            [css]="'upgrade-create-place'"></upgrade-button>
                        </div>

                        <mat-radio-group class="custom-edit-item radio-group"
                                         [disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents"
                                         [(ngModel)]="PDFSettings.pdf.headerImage.event.isDefault">
                            <mat-radio-button [value]="true">
                                Use default
                            </mat-radio-button>
                            <mat-radio-button [value]="false">
                                Customize
                            </mat-radio-button>
                        </mat-radio-group>

                        <ig-image-cropper
                            [class.hide]="PDFSettings.pdf.headerImage.event.isDefault||!(toggles.eventByGeolocation||toggles.manualEvents)"
                            #eventImgCropper [imageData]="PDFSettingImageCorperData.event"
                            [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>

                        <ig-button [disabled]="!toggles.eventByGeolocation&&!toggles.manualEvents" size="md"
                                   (trigger)="savePDFEventHeaderImage($event)" [isAsync]="true">save
                        </ig-button>
                    </div>

                    <!--          <div *ngIf="toggles&&toggles.eventLocationFilter" class="panel fixed-height-panel">-->
                    <!--            <div class="panel-header">-->
                    <!--              <h1>Event Locations</h1>-->
                    <!--            </div>-->
                    <!--            <ig-list>-->
                    <!--              <div header>-->
                    <!--                <ig-list-column-header>-->
                    <!--                  Event Locations-->
                    <!--                </ig-list-column-header>-->
                    <!--              </div>-->
                    <!--              <div body>-->
                    <!--                &lt;!&ndash; <ig-spinner *ngIf="isLoadingFeeds"></ig-spinner> &ndash;&gt;-->
                    <!--                <ng-container>-->
                    <!--                  <ig-list-item *ngFor="let location of eventLocationFilters">-->
                    <!--                    <div style="flex: 4">-->
                    <!--                      {{ location.locality }}-->
                    <!--                    </div>-->
                    <!--                    <ig-row-action-buttons style="flex: 1">-->
                    <!--                      <mat-icon matTooltip="Show widget Url"-->
                    <!--                                (click)="showLocationWidgetUrl(location, 'events')">-->
                    <!--                        web-->
                    <!--                      </mat-icon>-->
                    <!--                    </ig-row-action-buttons>-->
                    <!--                  </ig-list-item>-->
                    <!--                  <div *ngIf="!eventLocationFilters||!eventLocationFilters.length" class="empty-list">-->
                    <!--                    No Content Here...-->
                    <!--                  </div>-->

                    <!--                </ng-container>-->
                    <!--              </div>-->
                    <!--            </ig-list>-->
                    <!--          </div>-->
                </ig-col>
            </ig-row>
            <ig-row class="list-wrap">
                <ig-col [md]="6">
                    <!--                    <ig-row>-->
                    <!--                        <ig-col [md]="12">-->
                    <!--                            <div class="panel fb-place-wrap fixed-height-panel">-->
                    <!--                                <div class="panel-header">-->
                    <!--                                    <h1 [class.text-disabled]="!toggles.eventByGeolocation">Add Events from Eventful by URL</h1>-->
                    <!--                                    <mat-icon tip [class.text-disabled]="!toggles.eventByGeolocation" matTooltip="e.g., http://eventful.com/knoxville/venues/knoxville-civic-coliseum-/V0-001-000106838-3">-->
                    <!--                                        info-->
                    <!--                                    </mat-icon>-->
                    <!--                                    &lt;!&ndash;<upgrade-button [show]="!toggles.eventByGeolocation" [isSimple]="true" [css]="'upgrade-create-event'"></upgrade-button>&ndash;&gt;-->
                    <!--                                </div>-->
                    <!--                                <ig-field class="m-t-4"-->
                    <!--                                          label="Enter URL"-->
                    <!--                                          [(ngModel)]="eventPage.facebookPageUrlOrName"-->
                    <!--                                          [disabled]="!toggles.eventByGeolocation"-->
                    <!--                                          [isRequired]="true"-->
                    <!--                                          [formControl]="eventFormGroup.get('facebookPageUrlOrName')"-->
                    <!--                                ></ig-field>-->
                    <!--                                <ig-field-->
                    <!--                                        label="Display title (optional)"-->
                    <!--                                        [(ngModel)]="eventPage.displayTitle"-->
                    <!--                                        [isRequired]="false"-->
                    <!--                                        [disabled]="!toggles.eventByGeolocation"-->
                    <!--                                        [formControl]="eventFormGroup.get('displayTitle')"-->
                    <!--                                ></ig-field>-->
                    <!--                                &lt;!&ndash;                        <ig-select [(ngModel)]="urlSourceItems" label="Source"&ndash;&gt;-->
                    <!--                                &lt;!&ndash;                                   (itemSelected)="pageSourceChange($event)"&ndash;&gt;-->
                    <!--                                &lt;!&ndash;                                   [disabled]="!toggles.eventByGeolocation">&ndash;&gt;-->
                    <!--                                &lt;!&ndash;                        </ig-select>&ndash;&gt;-->
                    <!--                                <ig-button color="accent"-->
                    <!--                                           [isAsync]="true" size="md"-->
                    <!--                                           [disabled]="eventFormGroup.invalid||!toggles.eventByGeolocation"-->
                    <!--                                           (trigger)="addEventBriteOrEventfulPage($event)">-->
                    <!--                                    Add-->
                    <!--                                </ig-button>-->
                    <!--                            </div>-->
                    <!--                        </ig-col>-->

                    <!--                    </ig-row>-->
                    <!--                    <ig-row>-->
                    <!--                        <ig-col [md]="12">-->
                    <!--                            <div class="panel fb-place-wrap">-->
                    <!--                                <div class="panel-header">-->
                    <!--                                    <h1>Export Event PDF Header Image</h1>-->
                    <!--                                </div>-->

                    <!--                                <mat-radio-group class="custom-edit-item radio-group"-->
                    <!--                                                 [(ngModel)]="PDFSettings.pdf.headerImage.event.isDefault">-->
                    <!--                                    <mat-radio-button [value]="true">-->
                    <!--                                        Use default-->
                    <!--                                    </mat-radio-button>-->
                    <!--                                    <mat-radio-button [value]="false">-->
                    <!--                                        Customize-->
                    <!--                                    </mat-radio-button>-->
                    <!--                                </mat-radio-group>-->

                    <!--                                <ig-image-cropper *ngIf="!PDFSettings.pdf.headerImage.event.isDefault" #eventImgCropper-->
                    <!--                                                  [imageData]="PDFSettingImageCorperData.event"-->
                    <!--                                                  [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>-->

                    <!--                                <ig-button size="md" (trigger)="savePDFEventHeaderImage($event)" [isAsync]="true">save</ig-button>-->
                    <!--                            </div>-->
                    <!--                        </ig-col>-->
                    <!--                    </ig-row>-->
                </ig-col>
            </ig-row>
        </mat-tab>
        <mat-tab label="Places" [disabled]="!toggles.placeCalendar">
            <ng-template mat-tab-label>
                <mat-icon>map</mat-icon>
                Places
                <span style="margin-left: 64px" *ngIf="!toggles.placeCalendar">
                    <upgrade-button [show]="true" [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>
            </ng-template>

            <div class="panel">
                <div class="panel-header flex gap-4 items-center">
                    <div>
                        Try our AI Content Assistant
                        <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">
                        Bulk Generation
                    </div>
                    <ig-button (trigger)="bulkGeneration()">Start Update</ig-button>
                </div>
            </div>

            <ig-search-geofence [type]="'place'"></ig-search-geofence>

            <ig-row class="list-wrap">
                <ig-col [md]="6">
                    <ig-location-feed-list [type]="'place'"></ig-location-feed-list>
                </ig-col>
                <ig-col [md]="6">
                    <div *ngIf="placeSource==='facebook'" class="panel fb-place-wrap fixed-height-panel">
                        <div class="panel-header">
                            <h1 [class.text-disabled]="!toggles.placeCalendar">Add Facebook Places by URL</h1>
                            <mat-icon [class.text-disabled]="!toggles.placeCalendar" tip
                                      matTooltip="Add Facebook Places by URL">
                                info
                            </mat-icon>
                            <upgrade-button [show]="!toggles.placeCalendar"
                                            [css]="'upgrade-create-place'"></upgrade-button>
                        </div>
                        <ig-field label="Enter URL" [(ngModel)]="placePageFacebook.facebookPageUrlOrName"
                                  [isRequired]="true" [disabled]="!toggles.placeCalendar"
                                  [formControl]="placeFacebookFormGroup.get('facebookPageUrlOrName')"></ig-field>
                        <ig-field label="Display title (optional)" [(ngModel)]="placePageFacebook.displayTitle"
                                  [isRequired]="false" [disabled]="!toggles.placeCalendar"
                                  [formControl]="placeFacebookFormGroup.get('displayTitle')"></ig-field>
                        <ig-button color="accent" [isAsync]="true" size="md"
                                   [disabled]="placeFacebookFormGroup.invalid||!toggles.placeCalendar"
                                   (trigger)="addFBPage($event)">
                            Add
                        </ig-button>
                    </div>
                    <div *ngIf="placeSource==='google'">
                        <ig-search-google-place [hubName]="hubName" [enabled]="true"></ig-search-google-place>
                    </div>
                </ig-col>
            </ig-row>

            <ig-row>
                <ig-col [md]="6">
                    <div class="panel fb-place-wrap">
                        <div class="panel-header">
                            <h1 [class.text-disabled]="!toggles.placeCalendar">Create Place Manually</h1>
                            <upgrade-button [show]="!toggles.placeCalendar"
                                            [css]="'upgrade-create-place'"></upgrade-button>
                        </div>
                        <ig-hub-create-place></ig-hub-create-place>
                    </div>
                </ig-col>
                <ig-col [md]="6">
                    <div class="panel fb-place-wrap">
                        <div class="panel-header">
                            <h1>Export Place PDF Header Image</h1>
                        </div>

                        <mat-radio-group class="custom-edit-item radio-group"
                                         [(ngModel)]="PDFSettings.pdf.headerImage.place.isDefault">
                            <mat-radio-button [value]="true">
                                Use default
                            </mat-radio-button>
                            <mat-radio-button [value]="false">
                                Customize
                            </mat-radio-button>
                        </mat-radio-group>

                        <!--<div class="logo-corper" *ngIf="!PDFSettings.pdf.headerImage.place.isDefault">-->
                        <!--<img-cropper [image]="PDFSettingImageCorperData.place" (imageSet)="logoImageSet('place', true)"-->
                        <!--[settings]="cropperSettingsForPDF"></img-cropper>-->

                        <!--<ng-container>-->
                        <!--<p>Preview:</p>-->
                        <!--<img #pdfeventimage [src]="PDFSettingImageCorperData.place.image"-->
                        <!--alt="Please select an image from the above box"-->
                        <!--[width]="cropperSettingsForPDF.croppedWidth"-->
                        <!--[height]="cropperSettingsForPDF.croppedHeight">-->
                        <!--</ng-container>-->
                        <!--</div>-->

                        <ig-image-cropper #placeImgCropper [class.hide]="PDFSettings.pdf.headerImage.place.isDefault"
                                          [imageData]="PDFSettingImageCorperData.place"
                                          [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>

                        <ig-button size="md" (trigger)="savePDFPlaceHeaderImage($event)" [isAsync]="true">save
                        </ig-button>
                    </div>

                    <div class="panel fb-place-wrap">
                        <div class="panel-header">
                            <h1>Keep Temporarily Closed Places in Approved</h1>
                            <p class="m-b-2">If a place is temporarily closed, do you want it to be kept in approved?
                            </p>
                        </div>

                        <mat-radio-group class="custom-edit-item radio-group"
                                         [(ngModel)]="isKeepTempClosedPlaceInApproved"
                                         (change)="keepTempClosedInApproved()">
                            <mat-radio-button [value]="true">
                                YES
                            </mat-radio-button>
                            <mat-radio-button [value]="false">
                                NO
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!--          <div *ngIf="toggles&&toggles.placeLocationFilter" class="panel fixed-height-panel">-->
                    <!--            <div class="panel-header">-->
                    <!--              <h1>Place Locations</h1>-->
                    <!--            </div>-->
                    <!--            <ig-list>-->
                    <!--              <div header>-->
                    <!--                <ig-list-column-header>-->
                    <!--                  Place Locations-->
                    <!--                </ig-list-column-header>-->
                    <!--              </div>-->
                    <!--              <div body>-->
                    <!--                &lt;!&ndash; <ig-spinner *ngIf="isLoadingFeeds"></ig-spinner> &ndash;&gt;-->
                    <!--                <ng-container>-->
                    <!--                  <ig-list-item *ngFor="let location of placeLocationFilters">-->
                    <!--                    <div style="flex: 4">-->
                    <!--                      {{ location.locality }}-->
                    <!--                    </div>-->
                    <!--                    <ig-row-action-buttons style="flex: 1">-->
                    <!--                      <mat-icon matTooltip="Show widget Url"-->
                    <!--                                (click)="showLocationWidgetUrl(location, 'places')">-->
                    <!--                        web-->
                    <!--                      </mat-icon>-->
                    <!--                    </ig-row-action-buttons>-->
                    <!--                  </ig-list-item>-->
                    <!--                  <div *ngIf="!placeLocationFilters||!placeLocationFilters.length" class="empty-list">-->
                    <!--                    No Content Here...-->
                    <!--                  </div>-->

                    <!--                </ng-container>-->
                    <!--              </div>-->
                    <!--            </ig-list>-->
                    <!--          </div>-->
                </ig-col>

            </ig-row>

            <!--            <ig-row>-->
            <!--                <ig-col md="12">-->
            <!--                    <div class="panel fb-place-wrap">-->
            <!--                        <div class="panel-header">-->
            <!--                            <h1>Customize Place Categories</h1>-->
            <!--                        </div>-->
            <!--                        <ig-hub-customize-place-category></ig-hub-customize-place-category>-->
            <!--                    </div>-->
            <!--                </ig-col>-->
            <!--            </ig-row>-->
        </mat-tab>
        <mat-tab label="Itinerary Builder" [disabled]="!toggles.itinerary">
            <ng-template mat-tab-label>
                <mat-icon>directions_car</mat-icon>
                Itinerary Builder
                <span style="margin-left: 64px" *ngIf="!toggles.itinerary">
                    <upgrade-button [show]="!toggles.itinerary||!toggles.tripPlanner"
                                    [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>

            </ng-template>

            <ig-tour-management [type]="'tour'"></ig-tour-management>
        </mat-tab>
        <mat-tab label="Trip Planner" [disabled]="!toggles.tripPlanner">
            <ng-template mat-tab-label>
                <mat-icon>work</mat-icon>
                Trip Planner
                <span style="margin-left: 64px" *ngIf="!toggles.tripPlanner">
                    <upgrade-button [show]="!toggles.tripPlanner" [css]="'upgrade-trip-planner'"></upgrade-button>
                </span>

            </ng-template>
            <ig-tour-management [type]="'trip'"></ig-tour-management>
        </mat-tab>
        <mat-tab label="Block Keywords">
            <ng-template mat-tab-label>
                <mat-icon>block</mat-icon>
                Block Keywords
            </ng-template>
            <ig-block-keywords></ig-block-keywords>
        </mat-tab>
        <mat-tab *ngIf="toggles.ai.travelBuddy" label="AI Settings">
            <ng-template mat-tab-label>
                <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="" width="20">
                AI Settings
            </ng-template>
            <ig-ai-settings *ngIf="tab.selectedIndex===5"></ig-ai-settings>
        </mat-tab>
    </mat-tab-group>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/content.management.component.html